import CreateSchoolOpeningUpdates from './CreateSchoolOpeningUpdates';
export default CreateSchoolOpeningUpdates;